import { Outlet } from "react-router-dom";
import Brand from "@/components/common/Brand";

/**
 * Layout para pantallas públicas (Home pública y Login).
 * Sin barra inferior. Header minimalista con la marca.
 */
export default function PublicLayout() {
  return (
    <div className="relative min-h-[100dvh] bg-background text-foreground flex flex-col">
      <header className="sticky top-0 z-40 w-full glass border-b hairline">
        <div className="w-full max-w-5xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Brand />
        </div>
      </header>
      <main className="flex-1 w-full max-w-5xl mx-auto px-6 md:px-10 py-8 md:py-14">
        <Outlet />
      </main>
      <footer className="w-full border-t hairline">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
          <p className="text-xs text-muted-foreground">
            © Casino Tampiqueño · CT Connect
          </p>
          <p className="overline text-muted-foreground">Portal público</p>
        </div>
      </footer>
    </div>
  );
}
